export class HistoryManager {
    constructor(initialState) {
        this.past = [];
        this.future = [];
        this.currentState = typeof initialState === 'object' ? JSON.parse(JSON.stringify(initialState)) : initialState;
    }

    push(newState) {
        // Deep copy to store snapshot
        const snapshot = JSON.parse(JSON.stringify(this.currentState));
        this.past.push(snapshot);
        this.currentState = JSON.parse(JSON.stringify(newState));
        this.future = []; // Clear redo stack on new action
    }

    undo() {
        if (this.past.length === 0) return null;

        const previous = this.past.pop();
        // Push current to future
        this.future.push(this.currentState);

        this.currentState = previous;
        return this.currentState;
    }

    redo() {
        if (this.future.length === 0) return null;

        const next = this.future.pop();
        // Push current to past
        this.past.push(this.currentState);

        this.currentState = next;
        return this.currentState;
    }

    canUndo() {
        return this.past.length > 0;
    }

    canRedo() {
        return this.future.length > 0;
    }
}
